'use client';

import { Box, HStack } from '@terra/ui-styled-system';
import { ArrowUp02Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { Badge } from '../../../../../components/badge';
import { Text } from '../../../../../components/text';
import { WebSocketExecutionShell } from './WebSocketExecutionShell';
import type { WebSocketSendView } from './parse-websocket-execution-view';

type WebSocketSentViewProps = {
  view: WebSocketSendView;
};

export function WebSocketSentView({ view }: WebSocketSentViewProps) {
  const t = useTranslations('designSystem.chat.websocketClient');
  const tChat = useTranslations('designSystem.chat');
  const payload = view.formattedPayload ?? view.payload;

  return (
    <WebSocketExecutionShell
      mode="send"
      testId="websocket-execution-send"
      error={view.error}
      status={
        <Badge size="sm" variant="fill">
          {view.error ? tChat('failed') : view.queued ? t('queued') : t('sent')}
        </Badge>
      }
    >
      <HStack gap={1.5} alignItems="center">
        <ArrowUp02Icon size={10} color="var(--colors-fg-muted)" />
        <Text fontSize="xs" color="fg.muted">
          {t('sentMessage')}
        </Text>
      </HStack>
      {payload ? (
        <Box p={2} bg="bg.muted" borderRadius="sm" width="100%">
          <Text
            fontSize="xs"
            fontFamily="mono"
            color="fg.subtle"
            whiteSpace="pre-wrap"
            wordBreak="break-all"
          >
            {payload}
          </Text>
        </Box>
      ) : null}
      {view.sessionId ? (
        <HStack gap={1}>
          <Text fontSize="xs" color="fg.muted" flexShrink={0}>
            {t('sessionId')}
          </Text>
          <Text
            fontSize="xs"
            fontFamily="mono"
            color="fg.subtle"
            wordBreak="break-all"
          >
            {view.sessionId}
          </Text>
        </HStack>
      ) : null}
      {!view.error ? (
        <Text fontSize="xs" color="fg.muted">
          {view.queued ? t('queuedHint') : t('sentHint')}
        </Text>
      ) : null}
    </WebSocketExecutionShell>
  );
}
